import React from "react";
import works from "./works.json";
import "../../Styles/work.css";

import Work from "./Subcomponent/Work";

const Portfolio = () => {
  const featuredSystems = [
    {
      img: "/img/p1.webp",
      img2: "/img/p2.webp",
      img3: "/img/p3.webp",
      title: "Lead Capture & AI Follow-up System",
      descComp:
        "A conversion-focused system that captures leads, organizes data, and generates personalized follow-up responses automatically.",
      link1: "https://lvgarces.github.io",
      link2: "https://github.com/lvgarces",
      badge: "In progress",
    },
    {
      img: "/img/rr1.webp",
      img2: "/img/rr2.webp",
      img3: "/img/rr3.webp",
      title: "Lead Enrichment & Smart Outreach",
      descComp:
        "A workflow designed to enrich lead data and generate more relevant outbound messaging for better prospecting.",
      link1: "https://lvgarces.github.io",
      link2: "https://github.com/lvgarces",
      badge: "In progress",
    },
    {
      img: "/img/bm1.webp",
      img2: "/img/bm2.webp",
      img3: "/img/bm3.webp",
      title: "Conversion Dashboard",
      descComp:
        "A dashboard concept for tracking leads, scoring, and conversion performance in a clearer, more actionable way.",
      link1: "https://lvgarces.github.io",
      link2: "https://github.com/lvgarces",
      badge: "In progress",
    },
  ];

  return (
    <>
      <div className="container o-port">
        <h1 className="o-title-port">PROFESSIONAL PROJECTS</h1>
        <h2 className="o-subtitle-port">Featured Systems</h2>
        <div className="o-work">
          {featuredSystems.map((work, index) => (
            <Work
              key={`featured-${index}`}
              img={work.img}
              img2={work.img2}
              img3={work.img3}
              title={work.title}
              descComp={work.descComp}
              link1={work.link1}
              link2={work.link2}
              badge={work.badge}
            ></Work>
          ))}
        </div>
        <h2 className="o-subtitle-port">Frontend Projects</h2>
        <p className="o-port-context">
          These projects showcase my frontend foundation and development experience.
        </p>
        <div className="o-work">
          {works.map((works, index) => (
            <Work
              key={`work-${index}`}
              img={works.img}
              img2={works.img2}
              img3={works.img3}
              title={works.title}
              desc={works.desc}
              descComp={works.descComp}
              link1={works.link1}
              link2={works.link2}
            ></Work>
          ))}
        </div>
      </div>
    </>
  );
};
export default Portfolio;
